// Receipt generation utilities for Taxi-98

export const generateReceiptReference = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const sequence = String(Math.floor(Math.random() * 999) + 1).padStart(3, '0');
  
  return `TX98-${year}${month}${day}-${sequence}`;
};

export const formatCurrency = (amount) => {
  return `$${Number(amount).toFixed(2)} BSD`;
};

export const formatDateTime = (dateString, timeString) => {
  const date = new Date(`${dateString}T${timeString}`);
  return {
    date: date.toLocaleDateString('en-US', { 
      weekday: 'long',
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }),
    time: date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    })
  };
};

export const createReceipt = (tripData) => {
  const reference = generateReceiptReference();
  const { date, time } = formatDateTime(tripData.date, tripData.dropoffTime);
  
  return {
    id: reference,
    reference: reference,
    customerName: tripData.customerName,
    customerEmail: tripData.customerEmail,
    pickupLocation: tripData.pickupLocation,
    dropoffLocation: tripData.dropoffLocation,
    tripDate: date,
    dropoffTime: time,
    fareCollected: tripData.fareCollected,
    driverName: tripData.driverName,
    driverId: tripData.driverId,
    paymentMethod: 'Cash',
    notes: 'Payment was made directly to your driver.',
    createdAt: new Date().toISOString(),
    status: 'issued'
  };
};

export const saveReceipt = (receipt) => {
  const receipts = JSON.parse(localStorage.getItem('receipts') || '[]');
  receipts.push(receipt);
  localStorage.setItem('receipts', JSON.stringify(receipts));
  return receipt;
};

export const getAllReceipts = () => {
  return JSON.parse(localStorage.getItem('receipts') || '[]');
};

export const searchReceipts = (query) => {
  const receipts = getAllReceipts();
  const lowerQuery = query.toLowerCase();
  
  return receipts.filter(receipt => 
    receipt.reference.toLowerCase().includes(lowerQuery) ||
    receipt.customerName.toLowerCase().includes(lowerQuery) ||
    receipt.customerEmail.toLowerCase().includes(lowerQuery) ||
    receipt.driverName.toLowerCase().includes(lowerQuery)
  );
};
